import { render } from "./GetTlntReportForm.vue?vue&type=template&id=b2f0fdb4&scoped=true"
import script from "./GetTlntReportForm.vue?vue&type=script&lang=js"
export * from "./GetTlntReportForm.vue?vue&type=script&lang=js"

import "./GetTlntReportForm.vue?vue&type=style&index=0&id=b2f0fdb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2f0fdb4"]])

export default __exports__